import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,[_c(VCard,{staticClass:"mx-auto relative",attrs:{"max-width":"800"}},[_c(VBtn,{staticClass:"icon-close",attrs:{"to":"/parcels","fab":"","x-small":""}},[_c(VIcon,[_vm._v("mdi-close")])],1),(_vm.id)?_c('PostDetail',{attrs:{"id":_vm.id,"gallery-ref":_vm.galleryRef,"editable":false}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }